import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  BaseComponent,
  GridService,
  ignoreModalError,
  ModalService,
  NotificationService,
  TabGridComponent,
} from '../../../../tms-shared';
import { UserCustomer } from '../../models';
import { UserCustomerService } from '../../services';
import { UserCustomersCreateModalComponent } from '../user-customers-create-modal/user-customers-create-modal.component';

@Component({
  selector: 'app-user-customers',
  templateUrl: './user-customers.component.html',
  styleUrl: './user-customers.component.scss',
  imports: [TabGridComponent, AsyncPipe],
})
export class UserCustomersComponent extends BaseComponent implements OnInit {
  protected readonly userCustomerService = inject(UserCustomerService);
  private readonly gridService = inject(GridService);
  private readonly modalService = inject(ModalService);
  private readonly notificationService = inject(NotificationService);
  private readonly route = inject(ActivatedRoute);

  protected model$: Observable<UserCustomer[]>;

  private userId: string;

  protected fields: FormlyFieldConfig[];

  protected columnDefs: ColDef[] = [
    this.gridService.text('customerKey', $localize`Customer Account`),
    this.gridService.text('customerName', $localize`Customer`),
  ];

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  getModel() {
    this.model$ = this.userCustomerService.getForUser(this.userId);
  }

  create() {
    this.openUserCustomers(undefined, undefined, this.userId);
  }

  delete(model: UserCustomer) {
    this.userCustomerService
      .delete(model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.getModel(),
        error: () => this.notificationService.fail($localize`Delete User Customer failed`),
      });
  }

  private openUserCustomers(model: UserCustomer, id: string, userId?: string) {
    const { modal, component } = this.modalService.openMedium<UserCustomersCreateModalComponent>(
      UserCustomersCreateModalComponent,
    );
    component.model.set(model);
    component.id.set(id);
    component.userId.set(userId);
    modal.result.then(() => this.getModel(), ignoreModalError);
  }
}
